import { NgModule } from '@angular/core';
import { NgRenaultFeedbackComponent } from './ng-renault-feedback.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [NgRenaultFeedbackComponent],
  imports: [
    CommonModule
  ],
  entryComponents: [
    NgRenaultFeedbackComponent
  ],
  exports: [NgRenaultFeedbackComponent]
})
export class NgRenaultFeedbackModule {

  constructor() { }
  
}
